"use strict";

exports.__esModule = true;
exports["default"] = void 0;

function isEmpty(value) {
  return typeof value === 'undefined' || value === null || value === '';
}

var _default = isEmpty;
exports["default"] = _default;